import { useInView, defaultFallbackInView } from "react-intersection-observer";
defaultFallbackInView(true);

export default useInView;
